import type { ReactNode } from 'react';

import type { CouponIndex } from '../../schema/coupon/entry.js';
import AddCouponButton from './AddCouponButton.js';

type AddCouponsProps = {
  couponIndices: CouponIndex[];
  maxNumberOfCoupons: number;
  size?: React.ComponentProps<typeof AddCouponButton>['size'];
  onClick?: React.ComponentProps<typeof AddCouponButton>['onClick'];
};

/**
 * Component to render multi coupons.
 *
 * @param root0 Object containing the props
 * @param root0.couponIndices Active coupon indices
 * @param root0.maxNumberOfCoupons The maximum number of coupons
 * @param root0.size The size of the button, either 'sm' or 'md'
 * @param root0.onClick Optional onClick handler for tracking clicks on the add coupons button
 * @returns React element for multicoupon
 */
export default function AddCoupons({ couponIndices, maxNumberOfCoupons, size, onClick }: AddCouponsProps): ReactNode {
  return (
    <AddCouponButton
      className="w-full min-w-0 px-2 md:px-3 lg:min-w-18"
      disabled={couponIndices.length >= maxNumberOfCoupons}
      size={size}
      onClick={onClick}
    />
  );
}
